import { render, staticRenderFns } from "./ByDictSelect.vue?vue&type=template&id=ded2a2fc&scoped=true&"
import script from "./ByDictSelect.vue?vue&type=script&lang=js&"
export * from "./ByDictSelect.vue?vue&type=script&lang=js&"
import style0 from "./ByDictSelect.vue?vue&type=style&index=0&id=ded2a2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2a2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded2a2fc')) {
      api.createRecord('ded2a2fc', component.options)
    } else {
      api.reload('ded2a2fc', component.options)
    }
    module.hot.accept("./ByDictSelect.vue?vue&type=template&id=ded2a2fc&scoped=true&", function () {
      api.rerender('ded2a2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/ByDictSelect.vue"
export default component.exports